// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"27d5f1b7","237":"21fa724a","330":"d754f61e","427":"787e4183","449":"45cf240a","453":"2999e45c","503":"82346c00","525":"e85ecc0a","639":"01afc310","760":"c64f7f39","844":"2c071360","881":"97db9a49","965":"d868d2e8"}[chunkId] + ".chunk.js";
};